import React from "react";
import FormsUploader from "./FormsUploader.js";
import UploaderFooter from "./FormsUploaderFooter.js";
import UploaderHeader from "./FormsUploaderHeader.js";
import { useUploaderLogic } from "components/Pages/Home/Helpers/useUploaderLogic.js";
import { useDragUploader } from "components/Pages/Home/Helpers/useDragUploader.js";

export const UploaderComponent = ({ setFinishUpload, embedDesign }) => {
  const { filesCount, filesProgress } = useUploaderLogic({
    isEmbed: true,
    setFinishUpload,
  });

  const { handleDrop, handleDrag, dragged } = useDragUploader({});

  return (
    <div
      className="jm-form-uploader-container"
      onDrop={handleDrop}
      onDragOver={handleDrag}
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
    >
      <UploaderHeader />
      <FormsUploader filesProgress={filesProgress} dragged={dragged} />
      <UploaderFooter
        {...{
          embedDesign,
          filesCount,
          filesProgress,
        }}
      />
    </div>
  );
};

export default UploaderComponent;
